<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-divider class="mb-3"></v-divider>
        <v-simple-table fixed-header class="product-distributors-table">
            <template v-slot:default>
                <thead>
                <tr v-if="tableData.headers">
                    <th :class="!idx ? 'text-left' : 'text-center'" v-for="(header, idx) in tableData.headers" valign="top" :key="idx">{{ header }}</th>
                </tr>
                </thead>
                <tbody v-if="tableData.body">
                <tr v-for="item in tableData.body" :key="item.id">
                    <td>
                        <router-link :to="productLink(item)" class="teal--text">{{ distributorName(item) }}</router-link>
                    </td>
                    <td class="text-center">
                        <v-btn
                                text color="teal"
                                class="overline"
                                @click="showAttributes(item)"
                        >{{ $t('look') }}</v-btn>
                    </td>
                    <td class="text-center">
                        <div v-if="hasMinOrder(item)" v-html="minOrderString(item)" class="caption"></div>
                        <div v-if="!hasMinOrder(item)">
                            <v-icon color="red">cancel</v-icon>
                        </div>
                    </td>
                    <td class="text-center">
                        <div v-if="item.existence">
                            <v-icon color="teal">check</v-icon>
                        </div>
                        <div v-if="!item.existence">
                            <v-icon color="red">cancel</v-icon>
                        </div>
                    </td>
                    <td>
                        <div class="text-center">
                            {{ regionsString(item) }}
                        </div>
                        <div v-if="regionsCount(item) > 1" @click="showRegions(item)" class="teal--text d-flex justify-center" style="cursor: pointer;">
                            <v-btn
                                    color="teal"
                                    dark
                                    text
                                    @click="showRegions(item)"
                                    class="overline"
                                    height="20px"
                            >
                                ({{ $t('more').toLowerCase() }} {{ regionsCount(item) }})
                            </v-btn>
                        </div>
                    </td>
                    <td class="text-center">
                        {{ productPrice(item) }}
                    </td>
                    <td class="text-center px-0" width="130">
                        <actions
                                :id="item.id"
                                :is-favorite="isFavorite(item.id)"
                                :is-basket="isBasket(item.id)"
                                @cart="actionCart(item)"
                                @favorites="actionFavorites(item)"
                                @message="actionMessage(item)"
                        ></actions>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
        <attributes-dialog
                :attributes-data="dialogAttributes"
                :is-open="isAttributesOpen"
                @close="closeAttributes"
        ></attributes-dialog>
        <regions-dialog
                :regions-data="dialogRegions"
                :is-open="isRegionsOpen"
                @close="closeRegions"
        ></regions-dialog>
    </div>
</template>

<script>
    import AddToBasket from '../../../../app-front/mixins/AddToBasket';
    import Actions from './Actions';
    import AttributesDialog from './AttributesDialog';
    import BasketService from '../../../../app-front/services/api/BasketService';
    import Favorites from '../../../../app-front/mixins/Favorites';
    import FavoritesService from '../../../../app-front/services/api/FavoitesService';
    import ProductService from '../../../../app-front/services/api/ProductService';
    import RegionsDialog from './RegionsDialog';

    export default {
        name: "SellersTable",
        props:['tableData'],
        mixins:[Favorites, AddToBasket],
        components: {Actions, AttributesDialog, RegionsDialog},
        data() {
            return {
                dialogAttributes: [],
                dialogRegions: [],
                isAttributesOpen: false,
                isRegionsOpen: false,
                productLinkPrefix:'/products/'
            }
        },
        methods: {
            actionCart(product){
                const item = {
                    id: product.id,
                    quantity: 1
                };
                BasketService.updateList([item])
                    .then(res => {
                        this.$store.commit('setBasket', res.data)
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            actionFavorites(product){
                this.addFavorite(product.id)
            },
            actionMessage(product){
                this.$emit('seller-message', product);
            },
            closeAttributes() {
                this.isAttributesOpen = false;
            },
            closeRegions() {
                this.isRegionsOpen = false;
            },
            distributorName(product) {
                if(product.company && product.company.name) {
                    return product.company.name
                } else {
                    return product.seller
                }
            },
            hasMinOrder(product) {
                if(!product.minOrder) return false;

                return (product.minOrder.value);
            },
            minOrderString(product) {
                if (!product.minOrder || !product.minOrder.value) return '';

                let minPackName = product.minOrder.minPackName;
                let packName = product.minOrder.packName.toLowerCase();
                let value = product.minOrder.value ? 'x ' + product.minOrder.value : '';
                let minOrderString;

                if (product.minOrder.minPackName) {
                    minOrderString = `${minPackName.toLowerCase()}<br>(${packName} ${value})`;
                } else {
                    minOrderString = `${packName} ${value}`;
                }

                return minOrderString;
            },
            productPack(product) {
                if(product.pack && product.pack.name && product.pack.value) {
                    return product.pack.value + ' ' + product.pack.name;
                } else {
                    return this.$t('undefined');
                }
            },
            productLink(product) {
                return this.productLinkPrefix + product.id;
            },
            productPrice(product) {
                if(!product.price || !product.price.value || !product.price.currency) {
                    return $t('treaty');
                }

                return product.price.value + ' ' + product.price.currency.toUpperCase();
            },
            regions(product) {
                if(!product.regions || !product.regions.length) return [];

                return product.regions;
            },
            regionsString(product) {
                if(!product.regions || !product.regions.length) return '';

                const postfix = product.regions.length ? '' : '...';

                return product.regions[0] + postfix;
            },
            regionsCount(product) {
                if(!product.regions || !product.regions.length) return 0;

                return product.regions.length;
            },
            showAttributes(product) {
                const filters = {product_id: [product.id]};
                ProductService.getAtributes(filters)
                    .then(res => {
                        this.setAttributes(res.data);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            setAttributes(data){
                const result = {};

                data.forEach(item => {
                    if(!result[item.attribute_system_name]){
                        result[item.attribute_system_name] = {
                            'product_id': item.product_id,
                            'value_name': item.value_name,
                            'attribute_name': item.attribute_name,
                        };
                    } else {
                        result[item.attribute_system_name]['value_name'] = [
                            result[item.attribute_system_name]['value_name'], item.value_name].join(', ');
                    }
                });
                this.dialogAttributes = Object.values(result);
                this.isAttributesOpen = true;
            },
            showRegions(product) {
                this.dialogRegions = product.regions;
                this.isRegionsOpen = true;
            }
        }
    }
</script>

<style scoped>
    .product-distributors-table {
        min-height: 200px;
        max-height: 400px;
    }
</style>
